import React from "react";
import {Divider, List, NavBar} from "antd-mobile";
import {useNavigate} from "react-router-dom";
import {t} from "../../../i18n";
import {GlobalOutline} from "antd-mobile-icons";
import { getNavBarContainerStyle } from "../../../utils/deviceUtils";
import {TmsPath} from "../../../enums/TmsNavigatePathEnum";
import {ReactComponent as NavigationAppSvg} from "../icons/svgs/navigationApp.svg";


interface TransportSettingsProps {
}

const TransportSettingsPage: React.FC<TransportSettingsProps> = () => {
    const navigate = useNavigate();

    return (
        <div className="flex flex-col h-screen bg-white">
            <div {...getNavBarContainerStyle()}>
                <NavBar
                    onBack={() => navigate(-1)}
                >
                    {t('pages.tms.settings')}
                </NavBar>
            </div>
            <Divider/>
            <List
                className="flex-grow"
                style={{
                    '--border-bottom': 'none',
                    '--border-top': 'none',
                }}>
                <List.Item prefix={<GlobalOutline/>} onClick={() => {
                    navigate(TmsPath.TMS_TRANSPORT_SETTINGS_LANGUAGE)
                }}>
                    {t('pages.tms.language')}
                </List.Item>
                <List.Item prefix={<NavigationAppSvg width={19} height={19} />} onClick={() => { navigate(TmsPath.TMS_TRANSPORT_SETTINGS_NAVIGATION_APP) }}>
                    {t('pages.useMenu.navigationApp')}
                </List.Item>
            </List>

        </div>
    );
};

export default TransportSettingsPage;

